import { render } from "./area-single.vue?vue&type=template&id=f1a439b2&scoped=true"
import script from "./area-single.vue?vue&type=script&lang=js"
export * from "./area-single.vue?vue&type=script&lang=js"

import "./area-single.vue?vue&type=style&index=0&id=f1a439b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a439b2"]])

export default __exports__